// extracted by mini-css-extract-plugin
export default {"container":"list-loader_container__C4g2w","body":"list-loader_body__JjrMp"};